// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".instacours-date-time .base-multi-select .after{margin-left:16px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
